export default __webpack_public_path__ + "static/media/afterHero5.683f72ab.png";